import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timeDisplay', standalone: true })
export class TimeDisplayPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    // Remove seconds if they exist (e.g., "23:59:59" -> "23:59")
    let timeWithoutSeconds = value;
    const timeFormatLength = 5; // HH:MM format length
    if (value.includes(':') && value.split(':').length === 3) {
      timeWithoutSeconds = value.substring(0, timeFormatLength); // Take only HH:MM part
    }

    // Replace "23:59" with "24:00" in the string
    return timeWithoutSeconds.replace(/23:59/g, '24:00');
  }
}
